import { trigger, state, style, transition, animate, group, query } from '@angular/animations';
class IconAnimation {
  static menu(triggerName = 'menu') {
    return trigger(triggerName, [state('menu', style({})), state('top', style({
      transform: 'rotate(45deg) translate(2px, -4px)',
      transformOrigin: 'left'
    })), state('middle', style({
      opacity: 0
    })), state('bottom', style({
      transform: 'rotate(-45deg) translate(2px, 4px)',
      transformOrigin: 'left'
    })), transition('* => *', [animate('0.2s')])]);
  }
}
class OpenClosedAnimation {
  static toBottom(triggerName = 'toBottom') {
    return trigger(triggerName, [transition('void => *', [style({
      transform: 'translateY(100%)',
      opacity: 0
    }), animate('.3s ease-out', style({
      transform: 'translateY(0)',
      opacity: 1
    }))]), transition('* => void', [style({
      transform: 'translateY(0)',
      opacity: 1
    }), animate('.3s ease-out', style({
      transform: 'translateY(100%)',
      opacity: 0
    }))])]);
  }
  static toTop(triggerName = 'toTop') {
    return trigger(triggerName, [transition('void => *', [style({
      transform: 'translateY(-100%)',
      opacity: 0
    }), animate('.3s ease-out', style({
      transform: 'translateY(0)',
      opacity: 1
    }))]), transition('* => void', [style({
      transform: 'translateY(0)',
      opacity: 1
    }), animate('.3s ease-out', style({
      transform: 'translateY(-100%)',
      opacity: 0
    }))])]);
  }
  static toTopWithHeight(triggerName = 'toTopWithHeight') {
    return trigger(triggerName, [transition('void => *', [style({
      transform: 'translateY(-50%)',
      opacity: 0,
      height: '0px'
    }), animate('.3s ease-out', style({
      transform: 'translateY(0)',
      opacity: 1,
      height: '*'
    }))]), transition('* => void', [style({
      transform: 'translateY(0)',
      opacity: 1,
      height: '*'
    }), animate('.3s ease-out', style({
      transform: 'translateY(-50%)',
      opacity: 0,
      height: '0px'
    }))])]);
  }
  static height(triggerName = 'height') {
    return trigger(triggerName, [transition('void => *', [style({
      opacity: 0,
      height: '0px'
    }), animate('.3s ease-out', style({
      opacity: 1,
      height: '*'
    }))]), transition('* => void', [style({
      opacity: 1,
      height: '*'
    }), animate('.3s ease-out', style({
      opacity: 0,
      height: '0px'
    }))])]);
  }
  static heightWithPadding(triggerName = 'heightWithPadding') {
    return trigger(triggerName, [transition('void => *', [style({
      opacity: 0,
      height: '0px',
      'padding-top': '0px',
      'padding-bottom': '0px'
    }), animate('.3s ease-out', style({
      opacity: 1,
      height: '*',
      'padding-top': '*',
      'padding-bottom': '*'
    }))]), transition('* => void', [style({
      opacity: 1,
      height: '*',
      'padding-top': '*',
      'padding-bottom': '*'
    }), animate('.3s ease-out', style({
      opacity: 0,
      height: '0px',
      'padding-top': '0px',
      'padding-bottom': '0px'
    }))])]);
  }
}
class FadingSlideAnimation {
  static fadeInOut(triggerName = 'fadeInOut') {
    return trigger(triggerName, [transition('void => *', group([query('.slider-img', [style({
      transform: 'scale(0)',
      opacity: 0
    }), animate('.4s .15s ease-in-out', style({
      transform: 'scale(1)',
      opacity: 1
    }))]), query('.fading-layout', [style({
      transform: 'translateX(-15%)'
    }), animate('.4s .15s ease-in-out', style({
      transform: 'translateX(140%)'
    }))])])), transition('* => void', group([query('.slider-img', [style({
      transform: 'scale(1)',
      opacity: 1
    }), animate('.15s ease-in-out', style({
      transform: 'scale(.4)',
      opacity: 0
    }))]), query('.fading-layout', [style({
      transform: 'translateX(140%)'
    }), animate('.15s ease-in-out', style({
      transform: 'translateX(-15%)'
    }))])]))]);
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { FadingSlideAnimation, IconAnimation, OpenClosedAnimation };
